import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, X, ChevronDown, ChevronUp } from 'lucide-react';
import Logo from '../common/Logo';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPolicyDropdownOpen, setIsPolicyDropdownOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const togglePolicyDropdown = () => {
    setIsPolicyDropdownOpen(!isPolicyDropdownOpen);
  };
  return <header className="bg-white shadow-md sticky top-0 z-50" data-id="element-201">
      <div className="container mx-auto px-4 py-4" data-id="element-202">
        <div className="flex justify-between items-center" data-id="element-203">
          <Link to="/" className="flex items-center" data-id="element-204">
            <Logo data-id="element-205" />
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6" data-id="element-206">
            <Link to="/" className="text-gray-800 hover:text-blue-700 font-medium" data-id="element-207">
              Home
            </Link>
            <Link to="/service-coverage" className="text-gray-800 hover:text-blue-700 font-medium" data-id="element-208">
              Service Details
            </Link>
            <Link to="/soft-services" className="text-gray-800 hover:text-blue-700 font-medium" data-id="element-209">
              Soft Service Guides
            </Link>
            <Link to="/about-us" className="text-gray-800 hover:text-blue-700 font-medium" data-id="element-210">
              About Us
            </Link>
            <Link to="/contact-us" className="text-gray-800 hover:text-blue-700 font-medium" data-id="element-211">
              Contact Us
            </Link>
            <Link to="/faq" className="text-gray-800 hover:text-blue-700 font-medium" data-id="element-212">
              FAQs
            </Link>
            <div className="relative" data-id="element-213">
              <button onClick={togglePolicyDropdown} className="flex items-center text-gray-800 hover:text-blue-700 font-medium" data-id="element-214">
                Legal Terms{' '}
                {isPolicyDropdownOpen ? <ChevronUp size={16} data-id="element-215" /> : <ChevronDown size={16} data-id="element-216" />}
              </button>
              {isPolicyDropdownOpen && <div className="absolute right-0 mt-2 w-64 bg-white rounded-md shadow-lg py-2 z-50" data-id="element-217">
                  <Link to="/cancellation-policy" className="block px-4 py-2 text-gray-800 hover:bg-blue-50" onClick={() => setIsPolicyDropdownOpen(false)} data-id="element-218">
                    Cancellation Terms
                  </Link>
                  <Link to="/refund-policy" className="block px-4 py-2 text-gray-800 hover:bg-blue-50" onClick={() => setIsPolicyDropdownOpen(false)} data-id="element-219">
                    Refund Terms
                  </Link>
                  <Link to="/privacy-policy" className="block px-4 py-2 text-gray-800 hover:bg-blue-50" onClick={() => setIsPolicyDropdownOpen(false)} data-id="element-220">
                    Privacy & Cookie Notice
                  </Link>
                  <Link to="/terms-conditions" className="block px-4 py-2 text-gray-800 hover:bg-blue-50" onClick={() => setIsPolicyDropdownOpen(false)} data-id="element-221">
                    Terms & Conditions
                  </Link>
                </div>}
            </div>
          </nav>
          {/* Mobile Menu Button */}
          <button className="md:hidden" onClick={toggleMenu} data-id="element-222">
            {isMenuOpen ? <X size={24} data-id="element-223" /> : <MenuIcon size={24} data-id="element-224" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <nav className="mt-4 md:hidden" data-id="element-225">
            <div className="flex flex-col space-y-3 pb-4" data-id="element-226">
              <Link to="/" className="text-gray-800 hover:text-blue-700 font-medium" onClick={toggleMenu} data-id="element-227">
                Home
              </Link>
              <Link to="/service-coverage" className="text-gray-800 hover:text-blue-700 font-medium" onClick={toggleMenu} data-id="element-228">
                Service Details
              </Link>
              <Link to="/soft-services" className="text-gray-800 hover:text-blue-700 font-medium" onClick={toggleMenu} data-id="element-229">
                Soft Service Guides
              </Link>
              <Link to="/about-us" className="text-gray-800 hover:text-blue-700 font-medium" onClick={toggleMenu} data-id="element-230">
                About Us
              </Link>
              <Link to="/contact-us" className="text-gray-800 hover:text-blue-700 font-medium" onClick={toggleMenu} data-id="element-231">
                Contact Us
              </Link>
              <Link to="/faq" className="text-gray-800 hover:text-blue-700 font-medium" onClick={toggleMenu} data-id="element-232">
                FAQs
              </Link>
              {/* Mobile Policies Dropdown */}
              <div data-id="element-233">
                <button onClick={togglePolicyDropdown} className="flex items-center text-gray-800 hover:text-blue-700 font-medium w-full text-left" data-id="element-234">
                  Legal Terms{' '}
                  {isPolicyDropdownOpen ? <ChevronUp size={16} className="ml-2" data-id="element-235" /> : <ChevronDown size={16} className="ml-2" data-id="element-236" />}
                </button>
                {isPolicyDropdownOpen && <div className="pl-4 mt-2 flex flex-col space-y-2" data-id="element-237">
                    <Link to="/cancellation-policy" className="text-gray-800 hover:text-blue-700" onClick={toggleMenu} data-id="element-238">
                      Cancellation Terms
                    </Link>
                    <Link to="/refund-policy" className="text-gray-800 hover:text-blue-700" onClick={toggleMenu} data-id="element-239">
                      Refund Terms
                    </Link>
                    <Link to="/privacy-policy" className="text-gray-800 hover:text-blue-700" onClick={toggleMenu} data-id="element-240">
                      Privacy & Cookie Notice
                    </Link>
                    <Link to="/terms-conditions" className="text-gray-800 hover:text-blue-700" onClick={toggleMenu} data-id="element-241">
                      Terms & Conditions
                    </Link>
                  </div>}
              </div>
            </div>
          </nav>}
      </div>
    </header>;
};
export default Header;